import MultimidiaBase from "./MultimidiaBase";

export default class MultimidiaMariana extends MultimidiaBase { 
	constructor(props) {
		super(props);
		this.title = "Multimídia Mariana";

		this.groups = [
			{
				id: 1,
				name: "Monitoramento da Qualidade da Água do Rio Doce PEQ/COPPE/UFRJ",
				coordinators: "",
				videos: [
					{
						state: 'isOpenOxi',
						imgur: "/multimidia/oLn1ULI.png",
						titulo: "Demanda Química de Oxigênio (mgO2/L)",
						videoID: 'HVrHRHGx2SI',
						periodo: "Nov/2018 a Abr/2019 ",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenFerroTotal',
						imgur: "/multimidia/116MeEU.png",
						titulo: "Ferro Total (mg/L)",
						videoID: 'VMpVYV2UeKs',
						periodo: "Out-Nov/2016 e Dez/2018 a Abr/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenManganes',
						imgur: "/multimidia/ulceby4.png",
						titulo: "Manganês total (mg/L)",
						videoID: "RIwndkrRZn0",
						periodo: "Out-Nov/2016 e Out/2018 a Abr/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenTurbidez',
						imgur: "/multimidia/kijTqN1.png",
						titulo: "Cobre Dissolvido (mg/L)",
						videoID: 'mP93aJpucqI',
						periodo: "Média 2014/2015, Out-Nov/2016 e Out/2018 a Abr/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenFDissolvido',
						imgur: "/multimidia/Brkz2Pg.jpg",
						titulo: "Ferro Dissolvido (mg/L)",
						videoID: "IlmHdjDI9xQ",
						periodo: "Média 2014/2015 e Média 2016/2018/2019",
						metodo: "Interpolação Discreta"
					}
				]
			}
		];
	}
}


// WEBPACK FOOTER //
// ./src/components/Multimidia/MultimidiaMariana.js